import React, { useState } from 'react';

// components
import { DropdownSelectComponent } from 'baseComponents/DropdownSelectComponent';

// styles
import './filterRow.scss';

// types
import { AttributeType, OperatorType } from 'types/create-campaign';

// helpers
import {
  parseAttributesList,
  parseOperatorLabel,
  parseOperatorsList,
} from 'helpers/dropdown-data';

// store
import {
  useCreateNewAudienceActions,
  useCreateNewAudienceStore,
} from 'store/CreateNewAudienceStore';

// assets
import { CREATE_CAMPAIGN_SCREEN } from 'constants/enums/create-campaign-screen';
import { useGetAttributeValues } from 'hooks/useGetAttributeValues';
import { FilterRowValue } from '../FilterRowValue';
import createCampaignIcon from 'assets/icons/createCampaignIcon.svg';

var _ = require('lodash');

interface Props {
  attributesList: AttributeType[];
  itemId: string;
}

export const FilterRow: React.FC<Props> = (props) => {
  // zustand store
  const newAudienceFilters = useCreateNewAudienceStore(
    (state) => state.audienceFilters
  );

  const {
    removeFilterById: removeFilter,
    updateValue,
    updateOperator,
    updateAttribute,
    setEstimatedAudience,
  } = useCreateNewAudienceActions();

  const [getAttributeParams, setGetAttributeParams] = useState<any>();

  // current filter object
  const currentFilterInStore = _.find(_.flatten(newAudienceFilters), {
    id: props.itemId,
  });

  // chosen attribute in current filter
  const chosenAttribute: AttributeType = currentFilterInStore?.attribute;

  // chosen operator in current filter
  const chosenOperator: OperatorType = currentFilterInStore?.operator;

  const { data, isLoading } = useGetAttributeValues(getAttributeParams);

  const attributeValues = data?.results;
  const attributeValuesCount = data?.count;

  const handleChooseAttribute = async (item: AttributeType) => {
    const itemId = props!.itemId as string;
    updateAttribute(itemId, item);
    updateOperator(
      itemId,
      parsedOperatorList && parsedOperatorList.length > 0
        ? parsedOperatorList[0].value
        : ''
    );
    updateValue(itemId, '');
    setEstimatedAudience({
      sms: null,
      push: null,
    });
    if (item.type_keyword && item.table_reference) {
      setGetAttributeParams({
        type_keyword: item.type_keyword,
        table_reference: item.table_reference,
        search: '',
      });
    }
  };

  const handleChooseOperator = (item: OperatorType) => {
    const itemId = props!.itemId as string;
    updateOperator(itemId, item);
    updateValue(itemId, '');
    setEstimatedAudience({
      sms: null,
      push: null,
    });
  };

  const handleRemoveFilter = () => {
    const itemId = props!.itemId as string;
    removeFilter(itemId);
    setEstimatedAudience({
      sms: null,
      push: null,
    });
  };

  // list of attributes displayed in the dropdown
  const parsedAttributesList = parseAttributesList(
    props.attributesList,
    handleChooseAttribute
  );

  // list of operators displayed in a dropdown
  const parsedOperatorList = parseOperatorsList(
    currentFilterInStore?.attribute?.operators || [],
    handleChooseOperator
  );

  const handleSetAttirbuteValueQuery = (value: string) => {
    if (chosenAttribute.type_keyword && chosenAttribute.table_reference) {
      setGetAttributeParams({
        type_keyword: chosenAttribute.type_keyword,
        table_reference: chosenAttribute.table_reference,
        search: value,
      });
    }
  };

  return (
    <div className='filter-row'>
      <div className='row-left'>
        <div className='choose-audience-inputs'>
          <DropdownSelectComponent
            items={parsedAttributesList}
            selectLabelValue={
              currentFilterInStore?.attribute?.display_name ||
              currentFilterInStore?.attribute?.name ||
              CREATE_CAMPAIGN_SCREEN.CHOOSE_ATTRIBUTE
            }
          />
          {currentFilterInStore?.attribute && (
            <>
              <DropdownSelectComponent
                items={parsedOperatorList || []}
                selectLabelValue={
                  chosenOperator
                    ? parseOperatorLabel(chosenOperator)
                    : CREATE_CAMPAIGN_SCREEN.CHOOSE_OPERATOR
                }
              />
              <FilterRowValue
                tableReference={currentFilterInStore.attribute.table_reference}
                attributeType={
                  currentFilterInStore.attribute.attribute_type || ''
                }
                disable={!chosenOperator}
                currentFilterInStore={currentFilterInStore}
                itemId={props.itemId}
                dropdownValues={attributeValues || []}
                handleSetAttirbuteValueQuery={handleSetAttirbuteValueQuery}
                loading={isLoading}
                attributeValuesCount={attributeValuesCount || 0}
                chosenOperator={chosenOperator}
              />
            </>
          )}
        </div>
      </div>
      <div className='row-right'>
        <button className='remove-button' onClick={handleRemoveFilter}>
          <img
            className='remove-icon'
            src={createCampaignIcon}
            alt='remove icon'
          />
        </button>
      </div>
    </div>
  );
};
